<template>
  <div
    class="
      editDisabledPopupContainer
      flexContainer
      centerContainer
      columnContainer
    "
  >
    <p class="bigText">Spokojnie!</p>
    <p class="mediumText">
      Zablokowałam możliwość tworzenia nowych linków w tym artykule, ponieważ
      opisuję w nim istotę działania Wademekum. Spróbuj utworzyć swój artykuł
      <router-link
        style="color: #016d8f"
        :to="editableArticlePath"
        @click.native="closePopup"
        >gdzie indziej</router-link
      >
      lub
      <button class="linkAlike" style="font-size: 1em" @click="closePopup">wróć do czytania.</button>
    </p>
  </div>
</template>

<script>
export default {
  data() {
    return {
      editableArticleId: null,
      editableArticleTitle: null,
    };
  },
  methods: {
    closePopup() {
      this.$store.dispatch("deletePopupMessage");
    },
  },
  computed: {
    editableArticlePath() {
      return this.editableArticleTitle + "-" + this.editableArticleId;
    },
  },
  created() {
    this.$http.get("random/", { params: { editable: "True" } }).then(
      (response) => {
        this.editableArticleId = response.data.id;
        this.editableArticleTitle = response.data.title;
      },
      (error) => {
        console.log(error);
      }
    );
  },
};
</script>

<style scoped>
.editDisabledPopupContainer {
  width: 25%;
  height: 25%;
  margin-top: 15%;
  margin-left: 26%;
  border: 2px solid #394247;
  background-color: #ffffff;
  padding: 0.5%;
  box-shadow: 0 0 0 4px #fff, 0 0 0 6px #586471, 0 0 0 8px #fff,
    0 0 0 9px #586471;
}

p {
  line-height: 25px;
  margin: 2%;
}

button {
  text-decoration: none;
  color: #ec783e;
}

button:hover {
  text-decoration: underline;
}

@media (max-width: 1000px) {
  .editDisabledPopupContainer {
    margin-top: 53%;
    margin-left: 6%;
    width: 75%;
    height: 40%;
  }
}
</style>
